import { Suspense, type ReactNode } from 'react';

export function SuspenseWrap({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">
          …
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

// Tiny wrapper so route children inherit the Suspense boundary without each
// element having to repeat the boilerplate.
export const S = (el: ReactNode) => <SuspenseWrap>{el}</SuspenseWrap>;
